import React, { Fragment } from 'react';
import { ListItemButton, Typography, Collapse, Tooltip, InputLabel, FormControl, MenuItem, Stack, Alert, Select } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from "./Widgets/CustomToolbar";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import SuccessError from "./Widgets/SuccessError";
import Paper from '@mui/material/Paper';
import _without from "lodash/without";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import RadioGroup from '@mui/material/RadioGroup';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller } from "react-hook-form";
import moment from 'moment';
import { set } from 'date-fns';
import { de } from 'date-fns/locale';
import { GridEventListener } from '@mui/x-data-grid';
//import { InputLabel } from '@mui/icons-material';

const Vlans = () => {
    const [editVlanOpen, setEditVlanOpen] = React.useState(false);
    const [editIpRangeOpen, setEditIpRangeOpen] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [deleteName, setDeleteName] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);
    const [generalOpen, setGeneralOpen] = useState(true);
    const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
    const [accessToken, setAccessToken] = useState();
    const [refreshGrid, setRefreshGrid] = useState(0);
    const [selectedVlanId, setSelectedVlanId] = useState(0);
    const [entryDate, setEntryDate] = useState(null);
    const [ipRanges, setIpRanges] = useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [deleteEntity, setDeleteEntity] = React.useState('');



    const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
        '&.Mui-selected, &.Mui-selected:hover': {
            color: 'white',
            backgroundColor: selectedColor,
        },
    }));

    const useAsyncLoad = (url) => {
        const [errorA, setErrorA] = useState(null);
        const [loading, setLoading] = useState(true);
        const [networks, setNetworks] = useState(null);
        const { getAccessTokenSilently } = useAuth0();

        async function GetNetworksData(url) {

            const audience = 'https://piaapplication.azurewebsites.net/';

            const accessToken = await getAccessTokenSilently({
                audience: audience,

            });


            var bearer = 'Bearer ' + accessToken;

            var networksData = await fetch(url, {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                }
            });

            var data = await networksData.json();

            data.accessToken = accessToken;
            setAccessToken(accessToken);

            return data;

        };

        var x = 1;
        async function loadData(url) {

            try {

                setErrorA(null);
                // if (x < 2) {
                setLoading(true);
                //}

                var data = await GetNetworksData(url);

                setNetworks(data);
                //console.log(data);

            } catch (e) {

                setLoading(false);
                setErrorOpen(true);
            } finally {

                setLoading(false);
            }
        }

        useEffect(() => {
            loadData(url);
            // eslint-disable-next-line
        }, [refreshGrid]);


        return [networks, errorA, loading];
    }


    const FetchVlansAndIpRanges = () => {
        const [value, error, loading] = useAsyncLoad("networks/getvlansandipranges");

        return [value, error, loading];
    }


    var returnData = FetchVlansAndIpRanges();
    //var ipRanges = [];
    //console.log(returnData);
    if (returnData[0] !== null) {
        var vlans = returnData[0].vlans;
        //ipRanges = returnData[0].ipRanges;
    }

    //console.log(returnData);
    var loading = returnData[2];
    var error = returnData[1];

    const closeSuccess = () => {
        setSuccessOpen(false);
    };
    const closeError = () => {
        setErrorOpen(false);
    };

    const handleCancel = () => {
        setEditVlanOpen(false);

    };

    const handleCommonCancel = () => {
        setEditIpRangeOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    const IpRe = RegExp('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$');
    const validationSchema = Yup.object().shape({
        id: Yup.number()
            .required('Id is required'),
        name: Yup.string()
            .required('Name is required')
            .max(500, 'Name must not exceed 500 characters'),
        mask: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        defaultGateway: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        dns: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        dhcpRangeFrom: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        dhcpRangeTo: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid'),
        notes: Yup.string()
            .max(1000, 'Notes must not exceed 1000 characters'),

    });
    const ipRangeSchema = Yup.object().shape({
        //common data below
        ipAddress: Yup.string()
            .nullable()
            .matches(IpRe, 'IP is not valid')
            .max(1000, 'IP Address From must not exceed 1000 characters'),
        hostName: Yup.string()
            .nullable()
            .max(1000, 'must not exceed 1000 characters'),
        admin: Yup.string()
            .nullable()
            .max(1000, 'must not exceed 1000 characters'),
        entryDate: Yup.date()
            .nullable(),
    });

    const runValidations = () => {
        //debugger;
        validationSchema
            .validate(returnData[0].applications[2], { abortEarly: false })
            .then((responseData) => {
                console.log("no validation errors");
                console.log(responseData);
                console.log(errors);
                //setCurrentErrors([]);
            })
            .catch((err) => {
                console.log(err);
                console.log(err.name); // ValidationError
                console.log(err.errors);
                //setCurrentErrors(err.errors);
            });
    };

    const {
        register: registerVlan,
        control,
        setValue,
        handleSubmit: handleSubmitVlan,
        clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const {
        register: registerIpRange,
        controlCommon,
        setValue: setValueIpRange,
        handleSubmit: handleIpRange,
        clearerrorsIpRange,
        formState: { errors: errorsIpRange }
    } = useForm({
        resolver: yupResolver(ipRangeSchema)
    });
    const showSuccess = message => {
        setSuccessOpen(true);
        setSuccessMessage(message);
        setTimeout(() => setSuccessOpen(false), 3000);
    };

    const showError = message => {
        setErrorOpen(true);
        setErrorMessage(message);
        setTimeout(() => setErrorOpen(false), 3000);
    };
    async function saveVlan(data, saveOrAddOrDelete, accessToken) {

        var method = '';
        var url = ''
        if (saveOrAddOrDelete === 'Add') {
            method = 'POST';
            url = 'networks/saveVlan';
        } else if (saveOrAddOrDelete === 'Save') {
            method = 'PUT';
            url = 'networks/saveVlan';
        }
        else if (saveOrAddOrDelete === 'Delete') {
            method = 'DELETE';
            url = 'networks/saveVlan?id=' + data.id;
        }

        var bearer = 'Bearer ' + accessToken;

        try {
            const requestOptions = {
                method: method,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            var result = await fetch(url, requestOptions);


            if (result.status === 500) {
                showError("Error saving External IP");
            } else if (result.status === 404) {
                showError("Error saving External IP");
            }

            else {
                switch (saveOrAddOrDelete) {
                    case 'Save':
                        showSuccess("Update Successful");
                        break;
                    case 'Add':
                        showSuccess("New record added successfully");
                        break;
                    case 'Delete':
                        showSuccess("Record Deleted");
                        break;
                    default:
                        showSuccess("Update Successful");

                }

            }
        } catch (e) {

            showError();
        } finally {
            setRefreshGrid(refreshGrid + 1);
            //reRender = reRender + 1;
            //console.log(reRender);
        }
    }
    async function saveIpRangeData(data, saveOrAddOrDelete, accessToken) {

        var method = '';
        var url = ''
        if (saveOrAddOrDelete === 'Add') {
            method = 'POST';
            url = 'networks/saveIpRangeData';
        } else if (saveOrAddOrDelete === 'Save') {
            method = 'PUT';
            url = 'networks/saveIpRangeData';
        }
        else if (saveOrAddOrDelete === 'Delete') {
            method = 'DELETE';
            url = 'networks/saveIpRangeData?id=' + data.id;
        }

        var bearer = 'Bearer ' + accessToken;

        try {
            const requestOptions = {
                method: method,
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': bearer,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            var result = await fetch(url, requestOptions);


            if (result.status === 500) {
                showError("Error saving IP Range");
            } else if (result.status === 404) {
                showError("Error saving IP Range");
            }

            else {
                switch (saveOrAddOrDelete) {
                    case 'Save':
                        showSuccess("Update Successful");
                        break;
                    case 'Add':
                        showSuccess("New record added successfully");
                        break;
                    case 'Delete':
                        showSuccess("Record Deleted");
                        break;
                    default:
                        showSuccess("Update Successful");

                }

            }
        } catch (e) {

            showError();
        } finally {

            setRefreshGrid(refreshGrid + 1);
            //get the ip ranges again
            // var newData = returnData[0].ipRanges.filter(x => x.vlanId === selectedVlanId);
            // debugger;
            setIpRanges([]);
            setSelectedVlanId(0);
            //setIpRanges(null);

        }
    }
    const onSubmit = data => {
        //debugger;
        //runValidations();

        if (data.id === -1) {
            saveVlan(data, 'Add', accessToken);
        } else {
            saveVlan(data, 'Save', accessToken);
        }
        setEditVlanOpen(false);
    };

    const onSubmitIpRange = data => {

        //runValidations();
        //save here
        //debugger;
        data.vlanId = selectedVlanId;
        //console.log(data);
        if (data.id === -1) {
            saveIpRangeData(data, 'Add', accessToken);
        } else {
            saveIpRangeData(data, 'Save', accessToken);
        }

        setEditIpRangeOpen(false);
        return;

    };
    //grid columns
    const columns = [
        {
            field: "Actions", width: 150, sortable: false,
            disableExport: 'true',
            renderCell: (cellValues) => {
                return (

                    <div>
                        {/* {vendorData.userAndTenant.isSuperAdmin && */}
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickOpen(event, cellValues, returnData[0].accessToken);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {/* } */}

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleDeleteOpen(event, cellValues, 'Vlan');
                            }}
                        >
                            <DeleteIcon />
                        </Button>

                    </div>
                );
            }
        },
        {
            field: 'name', headerName: 'Name', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.name);

            }
        },
        // { field: 'phone', headerName: 'Phone', width: 130 },
        {
            field: 'mask', headerName: 'Mask', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.mask);

            }
        },
        {
            field: 'defaultGateway', headerName: 'Default Gateway', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.defaultGateway);

            }
        },
        {
            field: 'dns', headerName: 'DNS', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.description);

            }
        },
        {
            field: 'dhcpRange', headerName: 'DHCP Range', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.admin);

            }
        },

    ];
    const columnsIpRange = [
        {
            field: "Actions", width: 150, sortable: false,
            disableExport: 'true',
            renderCell: (cellValues) => {
                return (

                    <div>
                        {/* {vendorData.userAndTenant.isSuperAdmin && */}
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleClickIpRangeOpen(event, cellValues, returnData[0].accessToken);
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {/* } */}

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                                handleDeleteOpen(event, cellValues, 'IP Range');
                            }}
                        >
                            <DeleteIcon />
                        </Button>

                    </div>
                );
            }
        },
        {
            field: 'hostName', headerName: 'Host Name', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.hostName);

            }
        },
        // { field: 'phone', headerName: 'Phone', width: 130 },
        {
            field: 'admin', headerName: 'Admin', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.admin);

            }
        },
        {
            field: 'notes', headerName: 'Notes', minWidth: 190, flex: 1,
            renderCell: (cellValues) => {
                return (cellValues.row.notes);

            }
        },
        {
            field: 'entryDate', headerName: 'Entry Date', minWidth: 190, flex: 1,
            valueFormatter: (params) => params.value ? moment(params?.value).format("DD/MM/YYYY") : ''
        },


    ];


    const handleClickOpen = (event, cellValues, accessToken) => {

        var dataRow = cellValues.row;
        setValue("id", dataRow.id);


        if (dataRow.id > 0) {
            setEditOrAddTitle('Edit');

            setValue("name", dataRow.name);
            setValue("mask", dataRow.mask);
            setValue("defaultGateway", dataRow.defaultGateway);
            setValue("dhcpRangeFrom", dataRow.dhcpRangeFrom);
            setValue("dhcpRangeTo", dataRow.dhcpRangeTo);
            setValue("dns", dataRow.dns);
            setValue("notes", dataRow.notes);
            // setValue("entryDate", dataRow.entryDate);
            // setEntryDate(dataRow.entryDate);

            //setValue("deviceTypeId", dataRow.deviceTypeId);
        }
        // else {
        //     setEditOrAddTitle('Add');
        //     //set the default values
        //     setValue("hostname", '');
        //     setValue("access", '');
        //     setValue("authenticationDesc", '');
        //     setValue("funcionalPurpose", '');
        //     setValue("ips", '');
        //     setValue("vlan", '');
        //     setValue("manufacturer", '');
        //     setValue("model", '');
        //     setValue("serialNo", '');
        //     setValue("vendorInfo", '');
        //     setValue("url", '');
        //     setValue("eolDate", null);
        //     setValue("ports", '');
        //     setValue("cpu", '');
        //     setValue("avversioning", '');
        //     setValue("edr", '');
        //     setValue("operatingSystem", '');
        //     setValue("physicalLocation", '');
        //     setValue("memory", '');
        //     setValue("storageSize", '');
        //     setValue("warrantyInfo", '');
        //     setValue("backupDesc", '');
        //     setValue("riskLevel", 0);
        //     setValue("comments", '');

        //     setValue("deviceTypeId", 0);

        //}

        clearErrors();

        setEditVlanOpen(true);

    };
    const handleClickIpRangeOpen = (event, cellValues, accessToken) => {
        //debugger;
        var dataRow = cellValues.row;
        setValueIpRange("id", dataRow.id);



        if (dataRow.id > 0) {
            setEditOrAddTitle('Edit');

            setValueIpRange("hostName", dataRow.hostName);
            setValueIpRange("ipAddress", dataRow.ipAddress);
            setValueIpRange("notes", dataRow.notes);
            setValueIpRange("admin", dataRow.admin);
            setValueIpRange("entryDate", dataRow.entryDate);
            setEntryDate(dataRow.entryDate);

        }

        

        //

        clearErrors();

        setEditIpRangeOpen(true);

    };
    const handleDeleteOpen = (event, cellValues, deleteEntity) => {
        var dataRow = cellValues.row;
        setDeleteEntity(deleteEntity);
        if (deleteEntity === 'IP Range') {
            setDeleteName(dataRow.hostName);
            setDeleteId(dataRow.id)
        }
        else {
            setDeleteName(dataRow.name);
            setDeleteId(dataRow.id)
        }
        setDeleteOpen(true);
    };

    const handleDelete = () => {
        var data = { id: deleteId };
        if (deleteEntity === 'IP Range') {
            saveIpRangeData(data, 'Delete', accessToken);
        } else {
            saveVlan(data, 'Delete', accessToken);
        }
        //reRender = reRender + 1;
        setDeleteOpen(false);
    };
    const addVlan = (event, cellValues) => {

        setEditOrAddTitle('Add');
        setValue('id', -1);
        //set the default values
        setValue("name", '');
        setValue("mask", '');
        setValue("defaultGateway", '');
        setValue("dns", '');
        setValue("notes", '');
        setValue("dhcpRangeFrom", '');
        setValue("dhcpRangeTo", '');
        clearErrors();
        setEditVlanOpen(true);
    };
    const addIpRange = (event, cellValues) => {

        setEditOrAddTitle('Add');
        //set the default values
        setValueIpRange("ipAddress", '');
        setValueIpRange("hostName", '');
        setValueIpRange("notes", '');
        setValueIpRange("admin", '');
        setValueIpRange("entryDate", null);
        setValueIpRange("id", -1);


        setEntryDate(null);
        clearErrors();
        setEditIpRangeOpen(true);
    };
    const handleEvent = (
        params, // Gri\dRowParams
        event, // MuiEvent<React.MouseEvent<HTMLElement>>
        details, // GridCallbackDetails
    ) => {
        setSelectedVlanId(params.id);
        //set ip Ranges according to selection
        setIpRanges(returnData[0].ipRanges.filter(x => x.vlanId === params.id));
        // console.log(returnData[0].ipRanges);
        // console.log(ipRanges);

    };


    const titleBoxBackgroundColour = '#1976d21a';


    if (loading) {
        return (

            <DarkBackground >
                <LoadingOverlay
                    active={true}

                    spinner={true}
                    text="Loading..."
                >
                </LoadingOverlay>
            </DarkBackground>

        )
    }
    return (

        <div>
            <SuccessError
                successMessage={successMessage}
                errorMessage={errorMessage}
                closeError={() => closeError()}
                closeSuccess={() => closeSuccess()}
                successOpen={successOpen}
                errorOpen={errorOpen}
            >
            </SuccessError>

            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h3" component="h2">
                    Vlans
                </Typography>


                <Button variant="outlined" onClick={addVlan}>Add a Vlan</Button>
            </Box>
            <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
            </Box>


            <div style={{ height: '40vh', width: '100%' }}>
                <DataGrid

                    fullWidth
                    onRowClick={handleEvent}
                    rowSelectionModel={selectionModel} // version 6
                    selectionModel={selectionModel} // version 5

                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    initialState={{
                        pagination: {
                            pageSize: 1000,
                        },
                    }}
                    height='100%'
                    rows={vlans}
                    columns={columns}
                    //pageSize={100}
                    rowsPerPageOptions={[50, 100]}
                //checkboxSelection
                />

            </div>
            {selectedVlanId == 0 &&

                <Typography variant="h5" component="h5">
                    Select or add a Vlan to see IP Ranges
                </Typography>}
            {selectedVlanId > 0 &&
                <Fragment>
                    <Box
                        component="span"
                        m={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h3" component="h2">
                            IP Ranges
                        </Typography>


                        <Button variant="outlined" onClick={addIpRange}>Add an IP Range</Button>


                    </Box>
                    <div style={{ height: '40vh', width: '100%' }}>
                        <DataGrid

                            fullWidth

                            components={{
                                Toolbar: CustomToolbar,
                            }}
                            initialState={{
                                pagination: {
                                    pageSize: 1000,
                                },
                            }}
                            height='100%'
                            rows={ipRanges}
                            columns={columnsIpRange}
                            //pageSize={100}
                            rowsPerPageOptions={[50, 100]}
                        //checkboxSelection
                        />

                    </div>
                </Fragment>}

            <Dialog open={editVlanOpen} onClose={handleCancel} fullWidth maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '70%'
                    }
                }}
            >
                <DialogTitle
                    sx={{ padding: "3px 39px" }}
                >{editOrAddTitle} Vlan
                    <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
                        * = required
                    </Typography>

                </DialogTitle>

                <form>
                    <DialogContent>

                        <Fragment>
                            <Paper variant="outlined" >
                                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                    onClick={() => setGeneralOpen(!generalOpen)}
                                >
                                    <Grid container sx={{ justifyContent: "space-between" }} >
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            Vlan Information
                                        </Typography>
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                        </Typography>

                                    </Grid>
                                </Box>


                                <Collapse in={generalOpen} width={'100%'}>
                                    <Box sx={{ border: 1 }} px={1} py={2}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    required
                                                    id="id"
                                                    name="id"
                                                    label="ID"
                                                    fullWidth
                                                    hidden
                                                    margin="dense"
                                                    {...registerVlan('id')}

                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Name"
                                                    id="name"
                                                    name="name"
                                                    label="Name"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('name')}
                                                    error={errors.name ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.name?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Mask"
                                                    id="mask"
                                                    name="mask"
                                                    label="Mask"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('mask')}
                                                    error={errors.mask ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.mask?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Default Gateway"
                                                    id="defaultGateway"
                                                    name="defaultGateway"
                                                    label="Default Gateway"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('defaultGateway')}
                                                    error={errors.defaultGateway ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.defaultGateway?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} >
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="DNS"
                                                    id="dns"
                                                    name="dns"
                                                    label="DNS"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('dns')}
                                                    error={errors.dns ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.dns?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} >
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="dhcp Range From"
                                                    id="dhcpRangeFrom"
                                                    name="dhcpRangeFrom"
                                                    label="DHCP Range From"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('dhcpRangeFrom')}
                                                    error={errors.dhcpRangeFrom ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.dhcpRangeFrom?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="dhcp Range To"
                                                    id="dhcpRangeTo"
                                                    name="dhcpRangeTo"
                                                    label="DHCP Range To"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('dhcpRangeTo')}
                                                    error={errors.dhcpRangeTo ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.dhcpRangeTo?.message}
                                                </Typography>
                                            </Grid>
                                           

                                            <Grid item xs={12} sm={12}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Notes"
                                                    id="notes"
                                                    name="notes"
                                                    label="Notes"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerVlan('notes')}
                                                    error={errors.notes ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.notes?.message}
                                                </Typography>
                                            </Grid>



                                        </Grid>
                                    </Box>
                                </Collapse>

                            </Paper>
                        </Fragment>
                    </DialogContent>

                    <DialogActions>

                        <Button color="primary" onClick={handleSubmitVlan(onSubmit)}>Save</Button>

                        <Button onClick={handleCancel}>Cancel</Button>

                    </DialogActions>
                </form>

            </Dialog>


            <Dialog open={editIpRangeOpen} onClose={handleCommonCancel} fullWidth maxWidth="md"
                PaperProps={{
                    sx: {
                        minHeight: '50%'
                    }
                }}
            >
                <DialogTitle
                    sx={{ padding: "3px 39px" }}
                >{editOrAddTitle} IP Range
                    <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
                        * = required
                    </Typography>

                </DialogTitle>

                <form>
                    <DialogContent>

                        <Fragment>
                            <Paper variant="outlined" >
                                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                    onClick={() => setGeneralOpen(!generalOpen)}
                                >
                                    <Grid container sx={{ justifyContent: "space-between" }} >
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            IP Range Data
                                        </Typography>
                                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                            {generalOpen ? <RemoveIcon /> : <AddIcon />}
                                        </Typography>

                                    </Grid>
                                </Box>


                                <Collapse in={generalOpen} width={'100%'}>
                                    <Box sx={{ border: 1 }} px={1} py={2}>
                                        <Grid container spacing={1}>

                                            {/* <Grid item xs={12} sm={12}>
                                                <TextField
                                                    required
                                                    id="editCommon"
                                                    name="editCommon"
                                                    value={1}
                                                    fullWidth
                                                    hidden
                                                    margin="dense"
                                                    {...register('id')}

                                                />

                                            </Grid> */}
                                            {/* <Grid item xs={4} sm={4}>
                                                <TextField
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='From IP'
                                                    id="ipRangeFrom"
                                                    name="ipRangeFrom"
                                                    label="IP Range From"
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerIpRange('ipRangeFrom')}
                                                    error={errorsIpRange.ipRangeFrom ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.ipRangeFrom?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                                <TextField
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='To IP'
                                                    id="ipRangeTo"
                                                    name="ipRangeTo"
                                                    label="IP Range To"
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerIpRange('ipRangeTo')}
                                                    error={errorsIpRange.ipRangeTo ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.ipRangeTo?.message}
                                                </Typography>
                                            </Grid> */}
                                            <Grid item xs={4} sm={4}>
                                                <TextField
                                                    required
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='IP Address'
                                                    id="ipAddress"
                                                    name="ipRangeFrom"
                                                    label="IP Address"
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerIpRange('ipAddress')}
                                                    error={errorsIpRange.ipAddress ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.ipAddress?.message}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid item xs={4} sm={4}>
                                            </Grid> */}

                                            <Grid item xs={6} sm={6}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Host name"
                                                    id="hostName"
                                                    name="hostName"
                                                    label="Host name"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerIpRange('hostName')}
                                                    error={errorsIpRange.hostName ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.hostName?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} sm={6}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Administrator"
                                                    id="admin"
                                                    name="admin"
                                                    label="Administrator"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerIpRange('admin')}
                                                    error={errorsIpRange.admin ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.admin?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} sm={6}  >
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Notes"
                                                    id="notes"
                                                    name="notes"
                                                    label="Notes"
                                                    multiline
                                                    maxRows={3}
                                                    fullWidth
                                                    margin="dense"
                                                    {...registerIpRange('notes')}
                                                    error={errorsIpRange.notes ? true : false}
                                                />
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.notes?.message}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3} >
                                                {/* <FormControl sx={{ m: 0, width: 190 }}> */}
                                                {/* <InputLabel> Approved By </InputLabel> */}
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        id="entryDate"
                                                        name="entryDate"
                                                        label="Date"
                                                        {...registerIpRange('entryDate')}
                                                        value={entryDate}
                                                        onChange={(newValue) => {
                                                            setEntryDate(newValue);
                                                            setValueIpRange("entryDate", newValue);
                                                        }}
                                                        renderInput={(params) => <TextField  {...params} />}
                                                        error={errorsIpRange.entryDate ? true : false}
                                                    />

                                                </LocalizationProvider>
                                                <Typography variant="inherit" color="error.main">
                                                    {errorsIpRange.entryDate?.message}
                                                </Typography>
                                                {/* </FormControl> */}
                                            </Grid>

                                        </Grid>
                                    </Box>
                                </Collapse>

                            </Paper>
                        </Fragment>
                    </DialogContent>

                    <DialogActions>

                        <Button color="primary" onClick={handleIpRange(onSubmitIpRange)}>Save</Button>

                        <Button onClick={handleCommonCancel}>Cancel</Button>

                    </DialogActions>
                </form>

            </Dialog>

            <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Delete External IP</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you wish to Delete <strong>{deleteName} ?</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleDelete}>Delete</Button>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Vlans;